import {
    datetimeColDefCreator,
    downloadExportsButtonColDefCreator,
    rerunExportButtonColDefCreator,
    stringColDefCreator,
} from "./standard-col-def-creators"
import { formatDate } from "../../../new-custom-forms/templates/template_helpers"
import FiltersCellRenderer from "../cell-renderers/FiltersCellRenderer"
import { iTKExportFormat } from "../../../cached-data/types"
import { tFilterDef } from "../../../filters/types"

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getTkExportRunSettings = (exportFormat: iTKExportFormat, weeklyViewFilters: tFilterDef[]) => {
    return {
        tableName: "Export Format History",
        navId: "tkExportRun",
        resources: ["tkExportRuns"],
        filters: [],
        relatedNames: {
            tkExportRuns: {
                employees: ["/created_by"],
            },
        },
        colDefs: [
            datetimeColDefCreator({
                headerName: "Run at",
                field: "/created_on",
                sort: "desc",
            }),
            {
                ...stringColDefCreator({
                    headerName: "Run By",
                    field: "/created_by",
                }),
                width: 50,
            },
            stringColDefCreator({
                headerName: "Date Range",
                field: "/filters/start_date",
                // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
                valueGetter: params => {
                    return `${formatDate(params.data.filters.start_date)} - ${formatDate(
                        params.data.filters.end_date
                    )}`
                },
            }),
            {
                ...stringColDefCreator({
                    headerName: "Filters",
                    field: "/filters",
                }),
                cellRenderer: FiltersCellRenderer,
                cellRendererParams: {
                    weeklyViewFilters,
                },
                cellStyle: {
                    "text-overflow": "ellipsis",
                    overflow: "hidden",
                    "white-space": "nowrap",
                    "margin-top": "2px",
                },
            },
            {
                ...stringColDefCreator({
                    headerName: "Status",
                    field: "/processing_status",
                }),
                width: 50,
            },
            stringColDefCreator({
                headerName: "Additional Info",
                field: "/processing_result",
            }),
            rerunExportButtonColDefCreator({
                headerName: "",
                cellRendererParams: {
                    exportFormat,
                    weeklyViewFilters,
                },
            }),
            downloadExportsButtonColDefCreator({
                headerName: "",
            }),
        ],
        gridSettings: {
            rowHeight: 40,
            defaultColDef: {
                editable: false,
            },
            rowSelection: "multiple",
            // allow our click events to happen
            suppressRowClickSelection: true,
        },
        otherSettings: {
            pageTitle: "View History",
            rowLevelErrorDisplay: true,
            enableSearchBar: false,
            buttons: {},
        },
    }
}
